import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from './guards/auth.guard';
import { Error404Component } from './guards/error404/error404.component';
import { LoginGuard } from './guards/login/login.guard';
import { AuthGuardParticipante } from './guards/participante/auth.guard';

const routes: Routes = [
  {
    path: '',
    loadChildren: './login/login.module#LoginModule',
    canActivate: [LoginGuard]
  },

  {
    path: 'ambientes/:module_id',
    loadChildren: './ambientes/ambientes.module#AmbientesModule',
    canActivate: [AuthGuard],
    canLoad: [AuthGuard]
  },

  {
    path: 'area-do-participante',
    loadChildren:
      './area-participante/area-participante.module#AreaParticipanteModule',
    canActivate: [AuthGuardParticipante],
    canLoad: [AuthGuardParticipante]
  },

  {
    path: 'calendario',
    loadChildren: './calendario/calendario.module#CalendarioModule',
    canActivate: [AuthGuard],
    canLoad: [AuthGuard]
  },

  {
    path: 'calendario/:module_id',
    loadChildren: './calendario/calendario.module#CalendarioModule',
    canActivate: [AuthGuard],
    canLoad: [AuthGuard]
  },

  {
    path: 'colaborador',
    loadChildren: './colaboradores/colaboradores.module#ColaboradoresModule',
    canActivate: [AuthGuard],
    canLoad: [AuthGuard]
  },

  {
    path: 'colaboradores/:module_id',
    loadChildren: './colaboradores/colaboradores.module#ColaboradoresModule',
    canActivate: [AuthGuard],
    canLoad: [AuthGuard]
  },

  {
    path: 'equipamentos/:module_id',
    loadChildren: './equipamentos/equipamentos.module#EquipamentosModule',
    canActivate: [AuthGuard],
    canLoad: [AuthGuard]
  },

  {
    path: 'especialistas/:module_id',
    loadChildren: './especialistas/especialistas.module#EspecialistasModule',
    canActivate: [AuthGuard],
    canLoad: [AuthGuard]
  },

  {
    path: 'especialista',
    loadChildren: './especialistas/especialistas.module#EspecialistasModule',
    canActivate: [AuthGuard],
    canLoad: [AuthGuard]
  },

  {
    path: 'participante',
    loadChildren: './participantes/participantes.module#ParticipantesModule',
    canActivate: [AuthGuard],
    canLoad: [AuthGuard]
  },

  {
    path: 'participantes/:module_id',
    loadChildren: './participantes/participantes.module#ParticipantesModule',
    canActivate: [AuthGuard],
    canLoad: [AuthGuard]
  },

  {
    path: 'pesquisas/:module_id',
    loadChildren: './pesquisas/pesquisas.module#PesquisasModule',
    canActivate: [AuthGuard],
    canLoad: [AuthGuard]
  },

  {
    path: 'patrocinadores/:module_id',
    loadChildren: './patrocinadores/patrocinadores.module#PatrocinadoresModule',
    canActivate: [AuthGuard],
    canLoad: [AuthGuard]
  },

  { path: '**', component: Error404Component }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)], // {useHash: true}
  exports: [RouterModule]
})
export class AppRoutingModule { }
